import { ReportGmailerrorred } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { SocketContext } from "../../contexts";
import { useAppSelector } from "../../redux";
import { useLazyGetDocumentByIdQuery } from "../../redux/services";
import { convertSize } from "../../utils";

interface SizeProps {
  id: string;
  status: string;
  size: number;
}

const FileSize: React.FC<SizeProps> = ({ id, status, size }) => {
  const { receivedEvents } = useContext(SocketContext);

  const [getDocumentById] = useLazyGetDocumentByIdQuery();

  const uploads = useAppSelector(store => store.utils.uploads);

  const [currentStatus, updateStatus] = useState<string>(status);
  const [updatedSize, setSize] = useState<number>(size);

  const interval = React.useRef<NodeJS.Timeout>();

  let uploadDetail = uploads.find(u => u.id === id);

  const refetchDocumentStatus = () => {
    getDocumentById({ document_id: id }).unwrap().then((res: any) => {
      if (!res.title) {
        updateStatus(res.status);
        setSize(res.size);

        if (res.status !== 'pending') {
          clearInterval(interval.current);
        }
      }
    }).catch((err) => {
      console.error("Error Fetching Document: ", JSON.stringify(err));
    });
  };

  React.useEffect(() => {
    if (currentStatus === 'pending' && !uploadDetail) {
      refetchDocumentStatus();
      interval.current = setInterval(() => {
        refetchDocumentStatus();
      }, 60 * 1000);
    }
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (uploadDetail?.percentage === 100) {
      updateStatus("saved");
      setSize(uploadDetail?.size);
    } else if (uploadDetail) {
      setSize(uploadDetail?.size);
    }
    // eslint-disable-next-line
  }, [uploadDetail]);

  useEffect(() => {
    let document = receivedEvents?.["document-status"]?.[id] || {};
    if (currentStatus === "pending" && Object.keys(document).length > 0) {
      if (document?.status === "saved") {
        updateStatus("saved");
        setSize(document?.size ?? 0);
      } else if (document) {
        updateStatus(document?.status);
        setSize(document?.size);
      }
    }
    // eslint-disable-next-line
  }, [receivedEvents?.["document-status"], receivedEvents?.["document-status"]?.[id]]);

  return (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      {currentStatus === "pending" && <Typography variant="body2">{updatedSize ? convertSize(updatedSize ?? 0) : 'Calculating...'}</Typography>}
      {currentStatus === "saved" && (
        <Typography variant="body2">{convertSize(updatedSize ?? 0)}</Typography>
      )}
      {currentStatus === "failed" && (
        <ReportGmailerrorred color="error" fontSize="small" />
      )}
    </Box>
  );
};

export default FileSize;
